import React from 'react';
import tw, { styled } from 'twin.macro';
import { Link } from 'gatsby';

const Container = styled.div(({ hide }) => [
  tw`p-6 bg-green text-sm flex-row justify-center items-center font-medium fixed bottom-0 w-full z-30 transition-all duration-300 ease-out border-2	md:flex text-left border-current`,
  !hide && tw`translate-y-0 opacity-100`,
  hide && tw`translate-y-full opacity-0`,
]);

const Cookie = ({ hide, onClick }) => (
  <Container hide={hide} tw="z-[9999]">
    <span tw="block md:inline font-semibold text-center">
      This site uses cookies to improve your experience. By clicking, you agree
      to our{' '}
      <Link tw="underline" to="/legal">
        Privacy Policy
      </Link>
    </span>
    <button
      type="button"
      onClick={onClick}
      tw="bg-black text-white cursor-pointer px-4 font-semibold uppercase py-4 mx-auto mt-3  flex md:mx-5"
    >
      Accept cookies
    </button>
  </Container>
);

export default Cookie;
